export default __webpack_public_path__ + "static/media/Rectangle-blue.58d7fbda.svg";